import React from 'react';

const AuthenticationWithClick = (Component) => (props) => {
    const findClass = () => {
        switch (props.calssTYpe) {
            case 'disable':
                return props.userStore.getAuthenticationList()[props.authenticationKey] ? '' : 'disable';
            case 'dont_show':
                return props.userStore.getAuthenticationList()[props.authenticationKey] ? props.className : 'display-none';
            default :
                return props.className ? props.className : '';
        }
    };

    return (
        <Component
            {...props}
            onClick={props.userStore.getAuthenticationList()[props.authenticationKey] && props.onClick}
            className={findClass()}

        />);

};

export default AuthenticationWithClick;
